<h2 mat-dialog-title>{{ 'users.selectUsers' | t }}</h2>
<mat-dialog-content class="mat-typography">
  <mat-list class="user-list" *ngIf="data?.length; else empty" role="list">
    <mat-list-item *ngFor="let item of data; trackBy: trackByIndex; let i = index" role="listitem">
      <div class="user-list-item">
        {{ item.fullName }}
        <button mat-icon-button color="warn" (click)="deleteRequest(i)">
          <sn-icon fontSet="fal" fontIcon="fa-trash-alt" color="warn"> </sn-icon>
        </button>
      </div>
    </mat-list-item>
  </mat-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="warn" mat-dialog-close>{{ 'common.cancel' | t }}</button>
  <button mat-button color="success" [disabled]="!data.length" (click)="onSubmit()">{{ 'common.submit' | t }}</button>
</mat-dialog-actions>

<ng-template #empty> {{ 'map.tools.userSelectDialog.noUsersToSelect' | t }} </ng-template>
